<template>
  <div
    class="row-group"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ModalRowGroup',
};
</script>

<style lang="scss" scoped>
.row-group {
  margin-top: rem-calc(16);
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: var(--radius-xl);

  &> :not(:last-child) {
    border-bottom: 0.5px solid var(--border-secondary) !important;
  }
}
</style>
